export interface Port {
  key: string;
  name: string;
  zip: string;
}

export const PORTS: Port[] = [
  { key: 'Charleston', name: 'Charleston, SC', zip: '29403' },
  { key: 'Dallas', name: 'Dallas, TX', zip: '75241' },  
  { key: 'Houston', name: 'Houston, TX', zip: '77002' },
  { key: 'Jacksonville', name: 'Jacksonville, FL', zip: '32206' },
  { key: 'Norfolk', name: 'Norfolk, VA', zip: '23510' },
  { key: 'Savannah', name: 'Savannah, GA', zip: '31401' }
];
